const common = {
  nav: {
    getUmiGo: 'Obter UmiGo',
    downloadTitle: 'Baixar UmiGo',
    apkDownload: 'Download APK',
    apkDesc: 'Instalação direta',
    googlePlay: 'Google Play',
    googlePlayDesc: 'Dispositivos Android',
    appStore: 'App Store',
    appStoreDesc: 'Dispositivos iOS',
  },
  hero: {
    title1: 'UmiGo',
    title2: 'Seu Mundo',
    title3: 'Social',
    subtitle: 'Converse, jogue e conecte-se com sua família em um único app',
    watchDemo: 'Ver Demo',
  },
  features: {
    title: 'Tudo o que',
    titleLine2: 'você precisa',
    subtitle: 'Descubra os recursos que fazem do UmiGo seu app favorito',
    voiceChat: 'Chat de Voz',
    voiceChatDesc: 'Participe de salas de voz em tempo real com qualidade cristalina. Conecte-se com amigos e família na América Latina sem atrasos.',
    liveVideo: 'Vídeo ao Vivo',
    liveVideoDesc: 'Videochamadas cara a cara com até 12 pessoas simultaneamente',
    miniGames: 'Mini Jogos',
    miniGamesTag: '50+ jogos',
    miniGamesDesc: 'Jogue com amigos em nossa coleção de mini jogos divertidos',
    familySpaces: 'Espaços Familiares',
    familySpacesDesc: 'Crie grupos familiares privados com calendários, fotos e memórias compartilhadas',
    instantMessaging: 'Mensagens Instantâneas',
    instantMessagingDesc: 'Envie texto, mensagens de voz, fotos e vídeos com criptografia de ponta a ponta',
    virtualGifts: 'Presentes Virtuais',
    virtualGiftsDesc: 'Envie presentes virtuais e adesivos divertidos para se expressar nas conversas',
  },
  about: {
    tag: 'Nossa Comunidade',
    imageTitle1: 'Mais que',
    imageTitle2: 'um app',
    imageTitle3: 'uma família',
    title: 'Conecte-se com',
    titleLine2: 'quem mais importa',
    paragraph1: 'O UmiGo nasceu de uma ideia simples: aproximar famílias e amigos latino-americanos, não importa a distância. Entendemos a importância de permanecer conectado com seus entes queridos.',
    paragraph2: 'Nossa plataforma combina o melhor das redes sociais, entretenimento e ferramentas de comunicação projetadas especificamente para a comunidade LATAM. De chats de voz a mini jogos, cada recurso é criado para criar conexões significativas.',
    paragraph3: 'Junte-se a milhões de usuários na América Latina que fizeram do UmiGo seu lar digital. Seja conversando com a família, jogando com amigos ou conhecendo novas pessoas, o UmiGo torna tudo fácil e divertido.',
    joinButton: 'Junte-se ao UmiGo',
  },
  testimonials: {
    tag: 'Depoimentos',
    title: 'O que nossos',
    titleLine2: 'usuários dizem',
    user1: 'María Contreras',
    user1Since: 'Usuário desde 2024',
    user1Text: 'O UmiGo mudou completamente como me mantenho em contato com minha família no México. A qualidade do chat de voz é incrível, e meus filhos adoram os mini jogos!',
    user2: 'Juan Silva',
    user2Since: 'Usuário desde 2023',
    user2Text: 'O melhor app social para a América Latina! Fiz muitos amigos de diferentes países. O recurso de espaços familiares é perfeito para organizar reuniões.',
    user3: 'Ana Rodríguez',
    user3Location: 'Buenos Aires, Argentina',
    user4: 'Carlos Mendoza',
    user4Location: 'Lima, Peru',
    user4Text: 'Uso o UmiGo todos os dias para me conectar com minha equipe de jogos. A qualidade do vídeo é incrível e nunca temos atrasos!',
    user5: 'Laura Gómez',
    user5Text: 'Perfeito para se manter conectado com a família através das fronteiras. Adoro!',
    user6: 'Diego Pérez',
    user6Text: 'Os mini jogos são tão viciantes! Minha família inteira joga junta todo fim de semana.',
  },
  cta: {
    tag: 'Disponível Agora',
    imageTitle1: 'Baixe',
    imageTitle2: 'UmiGo',
    imageTitle3: 'Hoje',
    title: 'Comece sua',
    titleLine2: 'aventura social',
    description: 'Junte-se a milhões de usuários em toda a América Latina. Baixe o UmiGo agora e comece a se conectar com amigos e familiares em segundos. É grátis, rápido e divertido!',
    downloadButton: 'Obtenha UmiGo!',
  },
  footer: {
    title: 'Fique',
    titleLine2: 'Conectado',
    subtitle: 'Conecte-se conosco diretamente se você é influenciador, parceiro em potencial ou dirige uma agência',
    emailPlaceholder: 'seu@email.com',
    subscribeButton: 'Conectar',
    subscribing: 'Conectando...',
    successMessage: 'Conectado com sucesso!',
    errorMessage: 'Algo deu errado. Por favor, tente novamente.',
    linksTitle: 'Links',
    features: 'Recursos',
    games: 'Jogos',
    family: 'Família',
    download: 'Baixar',
    contactTitle: 'Contato',
    officeTitle: 'Escritório',
    officeAddress: 'Av. Paseo de la Reforma 222\nCidade do México, CDMX 06600\nMéxico',
    privacy: 'Privacidade',
    terms: 'Termos',
    copyright: '© 2025 UmiGo. Todos os direitos reservados.',
  },
};

export default common;
